import React, { useState } from "react";
import { FaPhone, FaTimes, FaMapMarkerAlt, FaGift, FaCalendarCheck, FaClock, FaPlus, FaMoneyBillWave, FaGifts } from "react-icons/fa";
import { motion } from 'framer-motion';
import { Tooltip } from 'react-tooltip'

import LiveContacts from "./LiveContacts";
import LiveLocation from "./LiveLocation";
import LiveGift from "./LiveGift";
import LiveDate from "./LiveDate";
import LiveRSVP from "./LiveRSVP";
import LiveSalamKaut from "./LiveSalamKaut";
import GiftIdeas from "../GiftIdeas";
import AddressDisplay from "../AddressDisplay";
import LiveAddress from "./LiveAddress";
import WishlistGridPublic from "../../plugins/wishlists/components/WishlistGridPublic";
import MoneyGiftPublic from "../../plugins/moneygift/components/MoneyGiftPublic";

function LiveBottomBar({ id, gift, contacts, directions, weddingDate, startTime, endTime, fontP, salamKaut, rsvp, addressData, contactsStatus, direction, rsvpStatus, moneyGift, wishlist }) {
  const modalVariants = {
    hidden: { opacity: 0, y: 100 }, // Start hidden and below the view
    visible: { opacity: 1, y: 0 },   // Visible and at original position
    exit: { opacity: 0, y: 100 }      // Exit animation
  };

  const [isOpen, setIsOpen] = useState(true);

  const [openModalType, setOpenModalType] = useState(null);
  // const storedGiftState = localStorage.getItem('gift_button');
  // const giftState = storedGiftState ? JSON.parse(storedGiftState) : true;
  // const [giftButton, setGiftButton] = useState(giftState);

  const toggleModal = (modalType) => {
    setOpenModalType((prevModalType) =>
      prevModalType === modalType ? null : modalType
    );
  };

  const handleCloseModal = () => {
    setOpenModalType(null);
  };

  const handleOverlayClick = (e) => {
    // Check if the click occurred on the overlay (background)
    if (e.target.classList.contains("overlay")) {
      handleCloseModal();
    }
  };

  const giftButton = JSON.parse(gift);
  const [isVisible, setIsVisible] = useState(false);

  const toggleButtons = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div>
      <div className="fixed bottom-0 left-0 w-full shadow-md py-2 z-30 bg-white/70">
        <div className="flex items-center justify-between md:justify-center px-3">
        {contactsStatus ? 
            <button
              rel="noopener noreferrer"
              className="flex items-center justify-center p-3"
              onClick={() => toggleModal("contacts")}
            >
              <FaPhone className="contact text-black text-2xl" />
            </button>
            : null
          }
          {direction ? 
            <button
              rel="noopener noreferrer"
              className="flex items-center justify-center p-3"
              onClick={() => toggleModal("location")}
            >
              <FaMapMarkerAlt className="contact text-black text-2xl" />
            </button>
            : null
          }
          {rsvpStatus ? (
            <div>
              <button
                rel="noopener noreferrer"
                className="flex items-center justify-center p-3"
                onClick={() => toggleModal("rsvp")}
              >
                <FaCalendarCheck className="rsvp text-black text-2xl" />
              </button>
              
              <Tooltip anchorSelect=".rsvp" place="top" isOpen={isOpen} variant="light">
                Don't forget to RSVPs
              </Tooltip>
            </div>
          ) : (
            <></>
          )}
          {wishlist ? (
            <div>
              <button
                rel="noopener noreferrer"
                className="flex items-center justify-center p-3"
                onClick={() => toggleModal("wishlist")}
              >
                <FaGifts className="text-black text-2xl" />
              </button>
            </div>
          ) : (
            <></>
          )}
          
          {/* {giftButton ? (
            <button
              rel="noopener noreferrer"
              className="flex items-center justify-center p-3"
              onClick={() => toggleModal("gift")}
            >
              <FaGift className="contact text-black text-2xl" />
            </button>
          ) : (
            <></>
          )}
            
          {(moneyGift && salamKaut) ? (
            <button
              className="flex items-center justify-center p-3"
              onClick={() => toggleModal("salamkaut")}
            >
              <FaMoneyBillWave className="contact text-black text-2xl" />
            </button>
          ) : null} */}

          <button
            rel="noopener noreferrer"
            className="flex items-center justify-center p-3"
            onClick={() => toggleModal("date")}
          >
            <FaClock className="contact text-black text-2xl" />
          </button>
        </div>
      </div>

      {openModalType === "contacts" && (
        <motion.div
          className={`fixed z-50 top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex items-end md:items-center justify-center overlay ${
            window.innerWidth <= 768 ? "mobile-sheet" : ""
          }`}
          onClick={handleOverlayClick}
          initial={{ opacity: 0 }} // Initial state for overlay
          animate={{ opacity: 1 }} // Animate to full opacity
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={`bg-white py-8 h-auto mb-20 px-3 rounded-lg w-full md:w-1/3 relative ${
              window.innerWidth <= 768 ? "mobile-sheet-content" : ""
            }`}
            variants={modalVariants}  // Use defined variants
            initial="hidden"          // Start with hidden variant
            animate="visible"         // Animate to visible when opened
            exit="exit"               // Exit with exit variant
            transition={{ duration: 0.5 }}
          >
            <button
              onClick={handleCloseModal}
              className="absolute top-0 right-0 m-4 text-gray-600 hover:text-gray-800 focus:outline-none"
            >
              <FaTimes />
            </button>
            <LiveContacts contacts={contacts} />
          </motion.div>
        </motion.div>
      )}

      {openModalType === "location" && (
        <motion.div
          className={`fixed z-50 top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex items-end md:items-center justify-center overlay ${
            window.innerWidth <= 768 ? "mobile-sheet" : ""
          }`}
          onClick={handleOverlayClick}
          initial={{ opacity: 0 }} // Initial state for overlay
          animate={{ opacity: 1 }} // Animate to full opacity
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={`bg-white py-8 h-auto mb-20 px-3 rounded-lg w-full md:w-1/3 relative ${
              window.innerWidth <= 768 ? "mobile-sheet-content" : ""
            }`}
            variants={modalVariants}  // Use defined variants
            initial="hidden"          // Start with hidden variant
            animate="visible"         // Animate to visible when opened
            exit="exit"               // Exit with exit variant
            transition={{ duration: 0.5 }}
          >
            <button
              onClick={handleCloseModal}
              className="absolute top-0 right-0 m-4 text-gray-600 hover:text-gray-800 focus:outline-none"
            >
              <FaTimes />
            </button>
            <LiveLocation directions={directions} />
          </motion.div>
        </motion.div>
      )}

      {openModalType === "rsvp" && (
        <motion.div
          className={`fixed z-50 top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex items-end md:items-center justify-center overlay ${
            window.innerWidth <= 768 ? "mobile-sheet" : ""
          }`}
          onClick={handleOverlayClick}
          initial={{ opacity: 0 }} // Initial state for overlay
          animate={{ opacity: 1 }} // Animate to full opacity
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={`bg-white py-8 h-5/6 overflow-auto mb-20 px-3 rounded-lg w-full md:w-1/3 relative ${
              window.innerWidth <= 768 ? "mobile-sheet-content" : ""
            }`}
            variants={modalVariants}  // Use defined variants
            initial="hidden"          // Start with hidden variant
            animate="visible"         // Animate to visible when opened
            exit="exit"               // Exit with exit variant
            transition={{ duration: 0.5 }}
          >
            <button
              onClick={handleCloseModal}
              className="absolute top-0 right-0 m-4 text-gray-600 hover:text-gray-800 focus:outline-none"
            >
              <FaTimes />
            </button>
            <LiveRSVP />
          </motion.div>
        </motion.div>
      )}

      {openModalType === "salamkaut" && (
        <motion.div
          className={`fixed z-50 top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex items-end md:items-center justify-center overlay ${
            window.innerWidth <= 768 ? "mobile-sheet" : ""
          }`}
          onClick={handleOverlayClick}
          initial={{ opacity: 0 }} // Initial state for overlay
          animate={{ opacity: 1 }} // Animate to full opacity
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={`bg-white py-8 h-5/6 overflow-auto mb-20 px-3 rounded-lg w-full md:w-1/3 relative ${
              window.innerWidth <= 768 ? "mobile-sheet-content" : ""
            }`}
            variants={modalVariants}  // Use defined variants
            initial="hidden"          // Start with hidden variant
            animate="visible"         // Animate to visible when opened
            exit="exit"               // Exit with exit variant
            transition={{ duration: 0.5 }}
          >
            <button
              onClick={handleCloseModal}
              className="absolute top-0 right-0 m-4 text-gray-600 hover:text-gray-800 focus:outline-none"
            >
              <FaTimes />
            </button>
            {(moneyGift && salamKaut) && (<LiveSalamKaut fontP={fontP} salamKaut={salamKaut} />)}
          </motion.div>
        </motion.div>
      )}

      {openModalType === "wishlist" && (
        <motion.div
          className={`fixed z-50 top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex items-end md:items-center justify-center overlay ${
            window.innerWidth <= 768 ? "mobile-sheet" : ""
          }`}
          onClick={handleOverlayClick}
          initial={{ opacity: 0 }} // Initial state for overlay
          animate={{ opacity: 1 }} // Animate to full opacity
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={`bg-white py-8 h-5/6 overflow-auto mb-20 px-3 rounded-lg w-full md:w-1/3 relative ${
              window.innerWidth <= 768 ? "mobile-sheet-content" : ""
            }`}
            variants={modalVariants}  // Use defined variants
            initial="hidden"          // Start with hidden variant
            animate="visible"         // Animate to visible when opened
            exit="exit"               // Exit with exit variant
            transition={{ duration: 0.5 }}
          >
            <button
              onClick={handleCloseModal}
              className="absolute top-0 right-0 m-4 text-gray-600 hover:text-gray-800 focus:outline-none"
            >
              <FaTimes />
            </button>
            {wishlist ? (
              <div className="space-y-12">
                {/* <LiveAddress data={addressData} /> */}
                <MoneyGiftPublic id={id} />
                <WishlistGridPublic id={id} />
                <GiftIdeas />
              </div>
            ) : (
              <></>
            )}
          </motion.div>
        </motion.div>
      )}

      {openModalType === "date" && (
        <motion.div
          className={`fixed z-50 top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex items-end md:items-center justify-center overlay ${
            window.innerWidth <= 768 ? "mobile-sheet" : ""
          }`}
          onClick={handleOverlayClick}
          initial={{ opacity: 0 }} // Initial state for overlay
          animate={{ opacity: 1 }} // Animate to full opacity
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={`bg-white py-8 h-auto mb-20 px-3 rounded-lg w-full md:w-1/3 relative ${
              window.innerWidth <= 768 ? "mobile-sheet-content" : ""
            }`}
            variants={modalVariants}  // Use defined variants
            initial="hidden"          // Start with hidden variant
            animate="visible"         // Animate to visible when opened
            exit="exit"               // Exit with exit variant
            transition={{ duration: 0.5 }}
          >
            <button
              onClick={handleCloseModal}
              className="absolute top-0 right-0 m-4 text-gray-600 hover:text-gray-800 focus:outline-none"
            >
              <FaTimes />
            </button>
            <LiveDate
              weddingDate={weddingDate}
              startTime={startTime}
              endTime={endTime}
              fontP={fontP}
            />
          </motion.div>
        </motion.div>
      )}
    </div>
  );
}

export default LiveBottomBar;
